export function getReportPdfFilename(artifact = {}) {
  const slug = (value) => String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80)
    .replace(/-+$/g, "");
  const title = slug(artifact.title);
  return `${title || `reporte-${slug(artifact.report_id) || "neuroa"}`}.pdf`;
}

// Parse only report-related SSE data; all other events remain ChatKit's concern.
export function createReportEventParser(onEvent) {
  let pending = "";
  let dataLines = [];

  const emit = () => {
    if (!dataLines.length) return;
    const data = dataLines.join("\n");
    dataLines = [];

    let event;
    try {
      event = JSON.parse(data);
    } catch {
      return;
    }

    if (event && event.type === "progress_update" && typeof event.text === "string" && event.text.trim()) {
      onEvent({ type: "progress_update", text: event.text });
    } else if (event && event.type === "artifact" &&
      ["artifact_type", "report_id", "title", "html_content", "download_url"]
        .every((field) => typeof event[field] === "string" && event[field].trim())) {
      onEvent(event);
    } else if (event && (
      (event.type === "response.output_item.added" &&
        event.item && event.item.type === "function_call" && event.item.name === "generate_report") ||
      (event.type === "workflow.task.added" && event.task &&
        (event.task.name === "generate_report" || event.task.tool_name === "generate_report"))
    )) {
      onEvent({ type: "generating" });
    }
  };

  const line = (value) => {
    if (!value) {
      emit();
    } else if (value.startsWith("data:")) {
      dataLines.push(value.slice(5).replace(/^ /, ""));
    }
  };

  return {
    push(chunk) {
      pending += chunk;
      let index;
      while ((index = pending.indexOf("\n")) !== -1) {
        line(pending.slice(0, index).replace(/\r$/, ""));
        pending = pending.slice(index + 1);
      }
    },
    end() {
      if (pending) line(pending.replace(/\r$/, ""));
      pending = "";
      emit();
    },
  };
}
